// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a62831b9","270":"18c2e941","404":"8ec4b6ea","498":"fa0e25c7","553":"553d7620","639":"7a5b810f","694":"7aa0cbff","725":"42311ed2"}[chunkId] + ".chunk.js";
};